import React from "react";
import NotificationPage from "../../NotificationPage";
import ForgottenPasswordLink from "../ForgottenPasswordLink";

const AccountLockedNotification = ({ missionName }) => (
  <NotificationPage
    title={`Your ${missionName} account  has been locked`}
    warningInfo="Your account was locked after too many log in attempts."
    info="To access your account you will need to reset your password using the link below. "
    action={<ForgottenPasswordLink />}
  ></NotificationPage>
);

export default AccountLockedNotification;
